import * as React from 'react';
import styled from 'styled-components';

const PricingItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  font-style: normal;
  font-weight: 500;
  line-height: 27px;
  font-size: 14px;
  text-align: right;

  color: #333333;
`;

interface props {
  title: string;
  price: string;
  style?: React.CSSProperties;
}

const PricingItem = (props: props) => {
  return (
    <PricingItemContainer style={props.style}>
      <div>{props.title}</div>
      <div>{props.price}</div>
    </PricingItemContainer>
  );
};

export default PricingItem;



// WEBPACK FOOTER //
// ./src/components/PricingItem.tsx